/**
 * it is used to format payouts according to BO settings for payoutFormat
 * It ca be either like 5:1, 1:09 or 4/0.750 or 4/11
 * Be careful to test all side effects if you change this code
 */
const PAYOUT_TYPE_MULTIPLIER = 'multiplier';
const PAYOUT_TYPE_FRACTIONAL = 'fraction';

// 'decimal' type is used only in retail games, see packages/retail/src/helpers/utils.ts
// if by mistake a non-retail game has BO config 'decimal',
// payout will be formatted with 'default' pattern
export const formatPayout = (value: number, type?: 'multiplier' | 'fraction' | 'decimal' | 'default') => {
  if (type === PAYOUT_TYPE_MULTIPLIER) {
    return `x${value + 1}`;
  }

  if (type === PAYOUT_TYPE_FRACTIONAL) {
    return `${value}/1`;
  }

  return `${value}:1`;
};
